import { Undo2, Redo2, ZoomIn, ZoomOut, Ruler, Layers, Image as ImgIcon, FileImage, FileJson } from "lucide-react";
import { BG_PX } from "@/editor/mercator";

import { tr } from "@/lib/i18n";
const Btn = ({ children, onClick, active, title, testid, disabled }) => (
  <button data-testid={testid} title={title} onClick={onClick} disabled={disabled}
    className={`h-9 px-2.5 rounded-md flex items-center gap-1.5 text-sm transition-colors disabled:opacity-40 ${active ? "bg-[#0F52BA] text-white" : "text-slate-600 hover:bg-slate-100"}`}>
    {children}
  </button>
);

export const Toolbar = ({ ed, view, setView, onUndo, onRedo, onExportPNG, onExportJSON }) => {
  const zoom = (f) => setView((v) => ({ ...v, scale: Math.max(0.1, Math.min(12, v.scale * f)) }));
  return (
    <div className="h-12 shrink-0 bg-white border-b border-slate-200 flex items-center px-3 gap-1" data-testid="editor-toolbar">
      <Btn testid="tb-undo" title={tr("Annulla (Ctrl+Z)")} onClick={onUndo} disabled={!ed.canUndo()}><Undo2 className="w-4 h-4" /></Btn>
      <Btn testid="tb-redo" title={tr("Ripeti (Ctrl+Y)")} onClick={onRedo} disabled={!ed.canRedo()}><Redo2 className="w-4 h-4" /></Btn>
      <span className="w-px h-6 bg-slate-200 mx-1" />
      <Btn testid="tb-zoom-in" title={tr("Ingrandisci")} onClick={() => zoom(1.2)}><ZoomIn className="w-4 h-4" /></Btn>
      <Btn testid="tb-zoom-out" title={tr("Riduci")} onClick={() => zoom(0.83)}><ZoomOut className="w-4 h-4" /></Btn>
      <span className="font-tech text-xs text-slate-400 w-12 text-center">{Math.round(view.scale * 100)}%</span>
      <span className="w-px h-6 bg-slate-200 mx-1" />
      <Btn testid="tb-dims" title={tr("Mostra quote")} active={ed.showDims} onClick={() => ed.toggle("showDims")}><Ruler className="w-4 h-4" /></Btn>
      <Btn testid="tb-zones" title={tr("Zone di carico vento")} active={ed.showZones} onClick={() => ed.toggle("showZones")}><Layers className="w-4 h-4" /></Btn>
      <Btn testid="tb-bg" title={tr("Mostra/nascondi sfondo")} active={ed.showBg} onClick={() => ed.toggle("showBg")}><ImgIcon className="w-4 h-4" /></Btn>
      <div className="flex-1" />
      <Btn testid="tb-export-png" title={tr("Esporta PNG")} onClick={onExportPNG}><FileImage className="w-4 h-4" /> PNG</Btn>
      <Btn testid="tb-export-json" title={tr("Esporta JSON")} onClick={onExportJSON}><FileJson className="w-4 h-4" /> JSON</Btn>
    </div>
  );
};
